export default "__VITE_ASSET__e12413ea__"